import { useMemo } from 'react'
import { useAuth } from '../../auth'
import { isSuperAdminUser } from '../../auth/core/permissionUtils'

/**
 * Effective permission check for Operations UI. Super admin bypass matches backend behavior.
 */
export function useOperationsAccess() {
  const { can, permissionsLoaded, currentUser } = useAuth()
  const isSuperAdmin = useMemo(() => {
    const isRoleIdSuperAdmin = Number((currentUser as any)?.role?.id) === 1
    return isRoleIdSuperAdmin || isSuperAdminUser(currentUser)
  }, [currentUser])

  const opCan = useMemo(
    () => (perm: string) => isSuperAdmin || can(perm),
    [isSuperAdmin, can]
  )

  return { opCan, permissionsLoaded, isSuperAdmin }
}
